export const NODES_GAP = 55;
export const NODE_HEIGHT = 110;
export const NODE_WIDTH = 200;
export const NODE_INFO_WIDTH = 395;

/**
 * LF360-1933 round 2: the Behavior Rules panel is wider than every other
 * node-info panel.
 *
 * A rule reads as a sentence of pills that wraps - condition, operator,
 * response, and for an adherence rule a threshold and a window on top of that -
 * so 395px was spending a third line on rules that are one thought.
 *
 * 450 is not a new number. Three node types in default-items-definition.ts
 * already opt into exactly this width through `cardWidth`, and tailwind.config.js
 * already defines `w-450` and safelists it. That safelist is load-bearing: the
 * panel applies its width as a dynamic `w-${...}` class (NodeInfo.tsx), which
 * Tailwind cannot see when it scans source, so a width outside the safelist
 * compiles to no rule at all and the panel silently renders at its intrinsic
 * width rather than at the number written here.
 */
export const BEHAVIOR_RULES_NODE_INFO_WIDTH = 450;

export const NODES_TO_PASTE_CONDITION_AFTER = ['message:multi', 'message:single', 'message:slider'];

export const ROOT_WRAPPER_CLASS = 'reactflow-wrapper';
export const MAX_HISTORY_LENGTH = 20;

export const ALLOWED_GOTO_TYPES = ['message:info', 'message:single', 'message:multi', 'message:suggestions', 'message:date', 'message:time', 'message:input', 'message:picker', 'fit:facts', 'scenario:picker', 'message:photo-picker'];
